import URI from "urijs";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
const ToolsStore = {
  testNaturalDate(keyword, userTimezone) {
    const { url } = ApiRoutes.ToolsApiController.naturalDateTest(
      encodeURIComponent(keyword),
      encodeURIComponent(userTimezone)
    );
    const promise = fetch("GET", qualifyUrl(url));
    promise.catch((errorThrown) => {
      if (errorThrown.additional.status !== 422) {
        UserNotification.error(
          `Loading keyword preview failed with status: ${errorThrown}`,
          "Could not load keyword preview"
        );
      }
    });
    return promise;
  },
  testGrok(pattern, namedCapturesOnly, string) {
    const { url } = ApiRoutes.ToolsApiController.grokTest();
    const promise = fetch("POST", qualifyUrl(url), {
      pattern,
      string,
      named_captures_only: namedCapturesOnly
    });
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "We were not able to run the grok extraction. Please check your parameters."
      );
    });
    return promise;
  },
  testJSON(flatten, listSeparator, keySeparator, kvSeparator, replaceKeyWhitespace, keyWhitespaceReplacement, keyPrefix, string) {
    const { url } = ApiRoutes.ToolsApiController.jsonTest();
    const payload = {
      flatten,
      list_separator: listSeparator,
      key_separator: keySeparator,
      kv_separator: kvSeparator,
      replace_key_whitespace: replaceKeyWhitespace,
      key_whitespace_replacement: keyWhitespaceReplacement,
      key_prefix: keyPrefix,
      string
    };
    const promise = fetch("POST", qualifyUrl(url), payload);
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "We were not able to run the JSON extraction. Please check your parameters."
      );
    });
    return promise;
  },
  testRegexValidity(regex) {
    const encodedRegex = URI.encode(regex);
    const { url } = ApiRoutes.ToolsApiController.regexValidate(encodedRegex);
    const promise = fetch("GET", qualifyUrl(url));
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "Could not validate regular expression. Make sure that it is valid."
      );
    });
    return promise;
  },
  urlAllowListCheck(urlToCheck) {
    const { url } = ApiRoutes.ToolsApiController.urlAllowlistCheck();
    const promise = fetch("POST", qualifyUrl(url), {
      url: urlToCheck
    });
    promise.catch((errorThrown) => {
      UserNotification.error(`Details: ${errorThrown}`, "Could not verify if the url is in the allowlist.");
    });
    return promise;
  },
  urlAllowListGenerateRegex(urlTemplate, placeholder) {
    const { url } = ApiRoutes.ToolsApiController.urlAllowlistGenerateRegex();
    const promise = fetch("POST", qualifyUrl(url), {
      url_template: urlTemplate,
      placeholder
    });
    promise.catch((errorThrown) => {
      UserNotification.error(`Details: ${errorThrown}`, "Could not generate regex.");
    });
    return promise;
  },
  testRegex(regex, string) {
    const { url } = ApiRoutes.ToolsApiController.regexTest();
    const promise = fetch("POST", qualifyUrl(url), {
      regex,
      string
    });
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "Could not try regular expression. Make sure that it is valid."
      );
    });
    return promise;
  },
  testRegexReplace(regex, replacement, replaceAll, string) {
    const { url } = ApiRoutes.ToolsApiController.regexReplaceTest();
    const payload = {
      regex,
      replacement,
      replace_all: replaceAll,
      string
    };
    const promise = fetch("POST", qualifyUrl(url), payload);
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "Could not try regular expression. Make sure that it is valid."
      );
    });
    return promise;
  },
  testSplitAndIndex(splitBy, index, string) {
    const { url } = ApiRoutes.ToolsApiController.splitAndIndexTest();
    const payload = {
      split_by: splitBy,
      index,
      string
    };
    const promise = fetch("POST", qualifyUrl(url), payload);
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "We were not able to run the split and index extraction. Please check your parameters."
      );
    });
    return promise;
  },
  testSubstring(beginIndex, endIndex, string) {
    const { url } = ApiRoutes.ToolsApiController.substringTest();
    const payload = {
      start: beginIndex,
      end: endIndex,
      string
    };
    const promise = fetch("POST", qualifyUrl(url), payload);
    promise.catch((errorThrown) => {
      UserNotification.error(
        `Details: ${errorThrown}`,
        "We were not able to run the substring extraction. Please check index boundaries."
      );
    });
    return promise;
  },
  testContainsString(searchString, string) {
    const { url } = ApiRoutes.ToolsApiController.containsStringTest();
    const promise = fetch("POST", qualifyUrl(url), {
      search_string: searchString,
      string
    });
    promise.catch((errorThrown) => {
      UserNotification.error(`Details: ${errorThrown}`, "Could not check if field contains the string");
    });
    return promise;
  },
  testLookupTable(lookupTableName, string) {
    const { url } = ApiRoutes.ToolsApiController.lookupTableTest();
    const promise = fetch("POST", qualifyUrl(url), {
      lookup_table_name: lookupTableName,
      string
    });
    promise.catch((errorThrown) => {
      UserNotification.error(`Details: ${errorThrown}`, "Could not check if lookup table translates the string");
    });
    return promise;
  }
};
export default ToolsStore;
